import styled from 'styled-components';
import { Modal as BootstrapModal } from 'react-bootstrap';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px;

  .MuiDataGrid-selectedRowCount {
    color: transparent !important;
  }
  .super-app-theme--header {
    background: #8850bf !important;
  }

  .super-app-theme--cell {
    text-align: center !important;
    align-items: center !important;
  }
  .actButtonsCredito {
    width: 100%;
    margin-top: 31px;
    display: flex;
    flex-direction: row;
  }
  .container-add-etiqueta {
    display: flex;
    align-items: flex-end; /* alinha a base do campo com o botão */
    gap: 4px;
    width: 100%;
  }

  /* faz o select ocupar todo o espaço restante */
  .container-add-etiqueta .select-flex {
    flex: 1 1 auto;
    min-width: 0; /* evita overflow em flex */
  }

  /* garante 100% dentro do wrapper */
  .container-add-etiqueta .select-flex > * {
    width: 100%;
  }

  /* evita “gambiarra” de margin-top fixa */
  .container-add-etiqueta button {
    margin-top: 0;
  }

  .flags {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    @media (min-width: 400px) {
      .flag:nth-child(2) {
        margin-left: 30px;
      }
    }
  }
`;

export const Modal = styled(BootstrapModal)`
  .modal-lg {
    max-width: 968px;
  }
  .modal-content {
    border-radius: 4px;
    padding: 5px 40px;
    margin-top: 10px;
  }
  .modal-header {
    padding-left: 0px;
    padding-right: 0px;
    .modal-title {
      color: #57069e;
      font-size: 1.2rem;
      /* font-family: 'Nunito Sans'; */
      font-weight: 600;
    }
  }
  .modal-body {
    padding: 0px;
    .row {
      margin-top: 20px;
    }
    .display-de-etiquetas {
      margin-top: 10px;
      padding: 0px 10px;
      overflow: auto;
      height: 550px;

      /* width */
      ::-webkit-scrollbar {
        width: 6px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        background: #c7c7c7;
      }

      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: #ababab;

        transition: 0.2s;
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: #969696;
      }
    }
  }
  .modal-footer {
    padding: 15px 0px;
    border: none;
  }
`;

export const StyledForm = styled.form`
  padding: 20px;
  border-radius: 5px;
  .inlineField {
    vertical-align: middle;
    margin: 5px 10px 5px 0;
  }
`;

export const ErrorMessage = styled.p`
  font-size: 11px;
  font-weight: 500;
  color: #db1212;
  margin-top: 2px;

  .iconStyle {
    font-size: 12px;
    margin-top: -3px;
    margin-right: 2px;
  }
`;

export const ButtonRow = styled.button`
  flex: 1;
  border: none;
  background-color: transparent;
  color: #3d3d3d;
  &:nth-child(2) {
    margin-left: 10px;
  }
  &:hover {
    background-color: #f4f5f7 !important;
    color: #000;
    transition: 0.4s;
  }
`;
